import { render, staticRenderFns } from "./function_promotion.vue?vue&type=template&id=af36c59a"
import script from "./function_promotion.vue?vue&type=script&lang=js"
export * from "./function_promotion.vue?vue&type=script&lang=js"
import style0 from "./function_promotion.vue?vue&type=style&index=0&id=af36c59a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports